import Dexie from 'dexie';
import { isNumber } from 'lodash';

const db = new Dexie('app') as any;

class Idb {
  constructor() {
    db.version(4).stores({
      allDistricts: 'id,name,province_id',
      allWards: 'id,name,district_id',
      localCache: 'id++,code,value',
    });
    console.log('Using Dexie v' + Dexie.semVer);
  }
  async getDistrict(id) {
    if (!id) return;
    return db.allDistricts.where('id').equals(id).first();
  }
  async getWard(id) {
    if (!id) return;
    return db.allWards.where('id').equals(id).first();
  }
  async getList(code) {
    const v = await db.localCache.where('code').equals(code).first();
    if (v && v.value) {
      return v.value;
    }
    return [];
  }
  async saveList(code, data) {
    const v = await db.localCache.where('code').equals(code).first();
    if (!v) {
      await db.localCache.bulkAdd([{ code, value: data }]);
    } else {
      await db.localCache
        .where('code')
        .equals('deliveryList')
        .modify({ value: data });
    }
  }

  async getDetailProvince(id) {
    if (!isNumber(id)) return;
    const districts = await db.allDistricts
      .where('province_id')
      .equals(id)
      .toArray();
    const wards = await db.allWards
      .where('district_id')
      .anyOf(districts.map((d) => d.id))
      .toArray();
    return [districts, wards];
  }
  async saveDistrictsWards(districts, wards) {
    await db.allDistricts.clear();
    await db.allDistricts.bulkAdd(districts);
    await db.allWards.clear();
    await db.allWards.bulkAdd(wards);
  }
  exec() {
    db.open()
      // .then(function () {
      //   return db.allDistricts.add({ id: 1, age: 42, district_id: 1 });
      // })
      .then(function () {
        return db.allDistricts.where('id').equals(1).toArray();
      })
      .then(function (friends) {
        console.log('Found friends: ' + JSON.stringify(friends, null, 2));
      })
      // .then(function () {
      //   return db.delete(); // So you can experiment again and again...
      // })
      .catch(Dexie.MissingAPIError, function (e) {
        alert(
          "Please use chrome-like browser for faster experience [Couldn't find indexedDB API]"
        );
        console.log("Couldn't find indexedDB API");
      })
      .catch('SecurityError', function (e) {
        alert(
          'Please use chrome-like browser for faster experience [SeurityError]'
        );
        console.log(
          "SeurityError - This browser doesn't like fiddling with indexedDB."
        );
        console.log(
          'If using Safari, this is because jsfiddle runs its samples within an iframe'
        );
        console.log(
          'Go run some samples instead at: https://github.com/dfahlander/Dexie.js/wiki/Samples'
        );
      })
      .catch(function (e) {
        console.log(e);
      });
  }
}

export const idb = new Idb();
